import {
  utils,
} from '@ama-sdk/core';
import {
  RegulatoryDetail,
  RegulatoryDetailsCategoryRequirement,
  RegulatoryDetailsReplyData,
} from '@dapi/sdk';
import {
  combineRegulatoryDetails,
  combineRegulatoryDetailsCategoryRequirements,
  combineRegulatoryDetailsRequirements,
  createRegulatoryDetailsReplyData,
  todayPlusNdays,
} from '@dapi/sdk/spec';
import {
  globalDob,
} from '../../../mock/dictionaries/dates';
import {
  travelers,
} from './journey-logic';

let missingDetails: RegulatoryDetailsCategoryRequirement[];
let storedDetails: RegulatoryDetail[];
let travelerId: string;

export const regulatoriesFirstPax: RegulatoryDetailsReplyData[] = [];
export const regulatoriesSecondPax: RegulatoryDetailsReplyData[] = [];

/**
 * Init regulatory details items for traveler
 *
 * @param id traveler id
 */
function initRegulatory(id: string) {
  missingDetails = combineRegulatoryDetailsCategoryRequirements([
    {
      isOptional: false,
      detailsCategory: 'personalDetails',
      detailsChoices: combineRegulatoryDetailsRequirements([
        {
          canBeDeclined: false,
          requiredDetailsFields: ['nationalityCountryCode']
        }
      ]).items
    }
  ]).items;

  storedDetails = combineRegulatoryDetails([{
    personalDetails:
    {
      birthDate: new utils.Date(globalDob),
      gender: 'male'
    }
  }]).items;

  travelerId = id;
}

export const regulatories: RegulatoryDetailsReplyData[] = [];

/**
 * Add Regulatory for first passenger
 */
function addRegulatory() {
  regulatoriesFirstPax.push(
    createRegulatoryDetailsReplyData({
      template: {
        ...regulatoriesFirstPax.at(-1),
        storedDetails,
        missingDetails,
        travelerId
      }
    }) as RegulatoryDetailsReplyData
  );
}

/**
 * Add Regulatory for second passenger
 */
function addRegulatorySecondPax() {
  regulatoriesSecondPax.push(
    createRegulatoryDetailsReplyData({
      template: {
        ...regulatoriesSecondPax.at(-1),
        storedDetails,
        missingDetails,
        travelerId
      }
    })
  );
}

initRegulatory('JOURNEY-TRAVELER-0-MOCK');

addRegulatory();

storedDetails = combineRegulatoryDetails([{
  personalDetails:
  {
    birthDate: new utils.Date(globalDob),
    gender: 'male',
    nationalityCode: 'IND'
  }
}]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'identityDocument',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'document',
        regulatoryType: 'passport'
      },
      {
        detailsType: 'document',
        regulatoryType: 'identityCard'
      }
    ]).items
  }
]).items;

addRegulatory();

storedDetails = combineRegulatoryDetails([
  {
    personalDetails:
    {
      birthDate: new utils.Date(globalDob),
      gender: 'male',
      nationalityCode: 'IND'
    }
  },
  {
    document: {
      documentType: 'passport',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceCountryCode: 'IN',
      nationalityCode: 'IND',
      name: travelers[1].names[0],
      number: '1111222233334444'
    }
  }
]).items;

missingDetails = [];

addRegulatory();

/*
* Regulatory calls for the second pax
*/

initRegulatory('JOURNEY-TRAVELER-1-MOCK');

addRegulatorySecondPax();

storedDetails = combineRegulatoryDetails([{
  personalDetails:
  {
    birthDate: new utils.Date(globalDob),
    gender: 'male',
    nationalityCode: 'IND'
  }
}]).items;

missingDetails = combineRegulatoryDetailsCategoryRequirements([
  {
    isOptional: false,
    detailsCategory: 'identityDocument',
    detailsChoices: combineRegulatoryDetailsRequirements([
      {
        detailsType: 'document',
        regulatoryType: 'passport'
      },
      {
        detailsType: 'document',
        regulatoryType: 'identityCard'
      }
    ]).items
  }
]).items;

addRegulatorySecondPax();

storedDetails = combineRegulatoryDetails([
  {
    personalDetails:
    {
      birthDate: new utils.Date(globalDob),
      gender: 'male',
      nationalityCode: 'IND'
    }
  },
  {
    document: {
      documentType: 'passport',
      expiryDate: new utils.Date(todayPlusNdays('09:00', 370)),
      issuanceCountryCode: 'IN',
      nationalityCode: 'IND',
      name: travelers[1].names[0],
      number: '1111222233334444'
    }
  }
]).items;

missingDetails = [];

addRegulatorySecondPax();

export const [getRegulatoryDetailsFirstPax, ...addRegulatoryDetailsFirstPax] = regulatoriesFirstPax;
export const [getRegulatoryDetailsSecondPax, ...addRegulatoryDetailsSecondPax] = regulatoriesSecondPax;
export const getRegulatoryDetailsFirstPaxCompleted = regulatoriesFirstPax.at(-1);
export const getRegulatoryDetailsSecondPaxCompleted = regulatoriesSecondPax.at(-1);
